module.exports = __webpack_public_path__ + "img/background18.a45c5287.jpg";